import type { Theme } from '@mui/material';

import type { SnackVariantKey } from '@clearverify/constants';

import type { SxProp } from 'src/types/mui';

export const buildStyles = (theme: Theme) => {
  const snackVariantsStyles = {
    success: {
      color: theme.palette.alert?.success?.contrastText,
      borderColor: theme.palette.alert?.success?.light,
      backgroundColor: theme.palette.alert?.success?.main,
      ...commonVariantStyles,
    },
    error: {
      color: theme.palette.alert?.error?.contrastText,
      borderColor: theme.palette.alert?.error?.light,
      backgroundColor: theme.palette.alert?.error?.main,
      ...commonVariantStyles,
    },
    info: {
      color: theme.palette.alert?.info?.contrastText,
      borderColor: theme.palette.alert?.info?.light,
      backgroundColor: theme.palette.alert?.info?.main,
      ...commonVariantStyles,
    },
    warning: {
      color: theme.palette.alert?.warning?.contrastText,
      borderColor: theme.palette.alert?.warning?.light,
      backgroundColor: theme.palette.alert?.warning?.main,
      ...commonVariantStyles,
    },
  } satisfies Record<SnackVariantKey, SxProp>;

  const snackTitleStyles = {
    textTransform: 'uppercase',
  } satisfies SxProp;

  const iconsStyles = {
    success: {
      color: theme.palette.alert?.success?.contrastText,
    },
    error: {
      color: theme.palette.alert?.error?.contrastText,
    },
    info: {
      color: theme.palette.alert?.info?.contrastText,
    },
    warning: {
      color: theme.palette.alert?.warning?.contrastText,
    },
  } satisfies Record<string, SxProp>;

  return {
    snackVariantsStyles,
    snackTitleStyles,
    iconsStyles,
  };
};

const commonVariantStyles = {
  width: '100%',
  border: '1px solid',
  borderRadius: 2,
} satisfies SxProp;
